module.exports = __webpack_public_path__ + "img/11.91533158.jpg";